import React from "react";
import { useDarkMode } from "src/context/DarkModeContext";
import ExplanationCard from "src/components/cards/ExplanationCard/ExplanationCard";
import ExampleCard from "src/components/cards/ExampleCard/ExampleCard";
import ConjugationTable from "src/components/tables/ConjugationTable";
import PageStructure from "src/components/wrappers/PageStructure";
import ExampleTitle from "src/components/ExampleTitle";

import {
    preteritoPluscuamperfectoExplanation,
    preteritoPluscuamperfectoExamples,
    preteritoPluscuamperfectoRegular,
    preteritoPluscuamperfectoIrregular
} from "src/data/individual-topics/PastPerfect";

const PreteritoPluscuamperfectoContent: React.FC = () => {
    const { isDarkMode } = useDarkMode();

    return (
        <div className={`${isDarkMode ? "dark" : ""}`}>

            <div className="section">
                <ExplanationCard cardData={preteritoPluscuamperfectoExplanation} />
            </div>

            <ExampleTitle />

            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {preteritoPluscuamperfectoExamples.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>

            <div className="section">
                <ConjugationTable
                    tableData={{
                        title: "Regular Past Perfect",
                        verbs: preteritoPluscuamperfectoRegular,
                    }}
                />
            </div>

            <div className="section">
                <ConjugationTable
                    tableData={{
                        title: "Irregular Past Perfect",
                        verbs: preteritoPluscuamperfectoIrregular,
                    }}
                />
            </div>
        </div>
    );
};

const PreteritoPluscuamperfectoScreen: React.FC = () => {
    return (
        <PageStructure
            TitleNode="Past Perfect"
            Page={<PreteritoPluscuamperfectoContent />}
        />
    );
};

export default PreteritoPluscuamperfectoScreen;
